
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
export default defineComponent({
  name: "modalChooseMajor",
  emits:["callBackFunc"],
  props: {
    arrMajor: Array as any,
    id: String,
    title: String,
  },
  methods: {
    showModal() {
        this.call_modal_delete.click()
    },
    closeModal(){
        this.admissionwinnerid = ''
        hideModal(this.addChooseMajor)
    },
    async submitComment() {
      if (this.admissionwinnerid == '') {
        return;
      }

      this.$emit("callBackFunc",this.admissionwinnerid)
      hideModal(this.addChooseMajor)
    },
  },
  mounted() {
    // console.log('title', this.title)
  },
  setup() {
    const addChooseMajor = ref<null | HTMLElement>(null);
    const call_modal_delete = ref<any>();
    const admissionwinnerid = ref('')
    function user() {
      let temp  = window.localStorage.getItem("user")
      return temp?JSON.parse(temp) : null
    }
    return {
        call_modal_delete,
        addChooseMajor,
        admissionwinnerid,
        user
    };
  },
});
